<template>
  <div>
    <div class="container">
      <div class="ui dividing header"></div>
      <div class="ui dividing header">
        <i class="boxes icon"></i> {{ $t("products") }}
      </div>
      <div class="ui warning message" v-if="!cart || !cart.length">
        {{ $t("no product selected yet") }}
      </div>
      <div class="ui divided cart selection list" v-else>
        <div
          class="item"
          v-for="(item, index) in cart"
          :key="index"
          @click="edit_item(item, index)"
        >
          <i class="map marker icon"></i>
          <div class="content">
            <div
              class="ui mini red right floated icon button"
              :data-tooltip="$t('delete')"
              @click.stop="delete_item(item, index)"
            >
              <i class="trash icon"></i>
            </div>
            <a class="ui right floated large basic green tag label">{{
              item.subtotal | formatCurrency(enterprise_setup.currency_iso)
            }}</a>
            <a
              @click.stop="select_alternate_price(index, vr.value)"
              style="margin-right: 10px"
              v-bind:class="{ hidden: !vr.value }"
              class="ui right floated basic label"
              v-for="(vr, idx) in item.product.setup.variations"
              :key="idx"
              >{{ vr.name }}
              {{ vr.value | formatCurrency(enterprise_setup.currency_iso) }}</a
            >
            <a
              style="margin-right: 10px"
              class="ui right floated small basic red label"
              v-if="item.discount_percentage"
            >
              -{{ item.discount_percentage }}% ({{
                ((item.quantity * item.discount_percentage * item.sale_price) /
                  100)
                  | formatCurrency
              }})
            </a>
            <a class="header">{{ item.quantity }} x {{ item.product.name }}</a>
            <div class="description">
              {{
                item.sale_price | formatCurrency(enterprise_setup.currency_iso)
              }}
              {{ $t("per unit") }}.
            </div>
          </div>
        </div>
      </div>
      <a class="ui orange right ribbon label">
        <div class="ui small horizontal right floated statistic">
          <div class="value">
            {{ total | formatCurrency(enterprise_setup.currency_iso) }}
          </div>
          <div class="label">{{ $t("total") }}</div>
        </div>
      </a>
    </div>
    <generic-container
      :title="$t('available product list')"
      icon="file alternate"
      style="margin-top:10px"
    >
      <table
        ref="table"
        class="ui celled selectable striped very compact table"
        style="width:100%"
      >
        <thead>
          <tr>
            <th>{{ $t("barcode") }}</th>
            <th>{{ $t("internal reference") }}</th>
            <th>{{ $t("product") }}</th>
            <th>{{ $t("sale price") }}</th>
          </tr>
        </thead>
        <tbody></tbody>
      </table>
    </generic-container>
    <template v-for="(mdl, index) in item_modals">
      <component
        :is="mdl"
        :key="index"
        :item="selected_item"
        v-on:finished="edit_succedded"
        @destroy="destroy_modals"
      ></component>
    </template>
  </div>
</template>

<script>
import { init_ajax_data_datables, enterprise_setup } from "@/utils";
import filters from "@/filters";
import "datatables.net";
import "datatables.net-se";
import ItemModal from "@/modules/point_of_sale/cart/PointOfSaleCartItemModal";
import { clone } from "../../../utils";
import GenericContainer from "@/components/GenericContainer";

// @ is an alias to /src
export default {
  name: "QuotationModalProducts",
  components: { GenericContainer },
  props: { quotation_in: Object },
  filters: filters,
  data() {
    return {
      cart: [],
      header_buttons: [
        {
          icon: "green refresh",
          tooltip: this.$t("refresh"),
          click: this.refresh,
        },
      ],
      item_modals: [],
      selected_item: undefined,
    };
  },
  computed: {
    total() {
      let _sum = this.cart.reduce(function(prev, current) {
        return prev + current.subtotal;
      }, 0);
      return _sum;
    },
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    edit_item(item) {
      // console.log("edit item", item);
      this.selected_item = item;
      this.item_modals.push(ItemModal);
    },
    delete_item(item, index) {
      this.cart.splice(index, 1);
    },
    item_subtotal(item) {
      let _consume = item.quantity * item.sale_price;
      let _discount =
        (item.quantity * (item.discount_percentage * item.sale_price)) / 100;
      return _consume - _discount;
    },
    add_to_cart(product) {
      // console.log(product);
      // this.cart.push(product);
      let trgt = this.cart.find((n) => n.product.uuid == product.uuid);
      if (trgt) {
        trgt.quantity++;
        trgt.subtotal = this.item_subtotal(trgt); //  trgt.quantity * trgt.sale_price;
      } else {
        this.cart.push({
          quantity: 1,
          product: {
            uuid: product.uuid,
            name: product.name,
            id: product.product_id,
            setup: JSON.parse(product.setup),
          },
          sale_price: product.sale_price,
          taxes: Number(product.setup.taxes_percentage),
          discount_percentage: 0,
          subtotal: Number(product.sale_price),
        });
      }
    },
    refresh() {
      let vm = this;
      let ent_setup = enterprise_setup(this);
      let columns = [
        {
          data: function(row) {
            return row.barcode;
          },
        },
        {
          data: function(row) {
            return row.internal_reference;
          },
        },
        {
          data: function(row) {
            return row.name;
          },
        },
        {
          data: function(row) {
            return filters.formatCurrency(
              row.sale_price,
              ent_setup.currency_iso,
            );
          },
        },
      ];

      let onSelect = function(data) {
        vm.add_to_cart(data);
      };

      init_ajax_data_datables(
        vm,
        vm.$refs.table,
        window.jQuery.fn.api.settings.api["pos products url"],
        columns,
        onSelect,
      );
    },
    edit_succedded(item) {
      let trgt = this.cart.find((n) => n.product.uuid == item.product.uuid);
      if (trgt) {
        trgt.quantity = item.quantity;
        trgt.sale_price = item.sale_price;
        trgt.discount_percentage = item.discount_percentage;
        trgt.subtotal = this.item_subtotal(trgt);
      }
    },
    destroy_modals() {
      this.item_modals = [];
    },
    get_product_list() {
      return this.cart;
    },
  },
  mounted() {
    this.refresh();
  },
  beforeMount() {
    let vm = this;
    if (
      vm.quotation_in &&
      vm.quotation_in.setup &&
      vm.quotation_in.setup.products
    ) {
      vm.cart = clone(vm.quotation_in.setup.products);
    }
  },
  watch: {},
};
</script>

<style></style>
